import React from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../services/api';
import { useContentList } from '../../hooks/useContent';
import { getImageUrl } from '../../utils/imageUrl';

function ResortInner() {
  const { items: resorts, loading, error } = useContentList(
    () => api.getResorts({ per_page: 100 }),
    []
  );

  if (!loading && !error && !resorts.length) {
    return null;
  }

  return (
    <div className="space">
      <div className="container">
        {loading && <p className="text-center">Loading resorts...</p>}
        {error && <p className="text-center text-danger">{error}</p>}
        <div className="row gy-30">
          {resorts.map((resort) => (
            <div className="col-xl-4 col-md-6" key={resort.id}>
              <div className="tour-box th-ani">
                <div className="tour-box_img global-img">
                  <img
                    src={getImageUrl(resort.image, 'resort')}
                    alt={resort.title || 'Resort'}
                  />
                </div>
                <div className="tour-content">
                  <h3 className="box-title">
                    <Link to={`/resort/${resort.id}`}>{resort.title}</Link>
                  </h3>
                  {resort.price && (
                    <h4 className="tour-box_price">
                      <span className="currency">{resort.price}</span>/Night
                    </h4>
                  )}
                  {resort.location && (
                    <p className="destination-text">{resort.location}</p>
                  )}
                  <Link to={`/resort/${resort.id}`} className="th-btn style4 th-icon">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ResortInner;
